<div class="loading-screen" [ngClass]="{ 'horizontal-vertical-center': centered}">
  <mat-progress-spinner diameter="75" mode="indeterminate" [ngClass]="{ 'inverted-spinner': invertedColor}"></mat-progress-spinner>
  <h2>{{ title }}...</h2>
  <h3>{{ description }}</h3>
</div>
